import BaseMessageHandler from '../BaseMessageHandler';
import { deleteDataItem } from 'actions/getData';
import tableNames from 'constants/tableNames';

export default class Rcs_DeleteElement extends BaseMessageHandler {
  success = () => {
    const { dispatch, message } = this;
    const { payload } = message;

    dispatch(deleteDataItem(tableNames.rcs, 'id', payload.id));
  };
}
